import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import IdleTimer from 'react-idle-timer'
import {logout} from 'core/actions/gigya'
import PropTypes from 'prop-types'

class IdleHandler extends Component {
    static defaultProps = {
      user: null,
      session_lifetime: null
    }
    static propTypes = {
      user: PropTypes.object,
      session_lifetime: PropTypes.string
    }

    constructor (props) {
      super(props)
      this.idleTimer = null
      this.handleOnIdle = this.handleOnIdle.bind(this)
    }

    handleOnIdle = () => {
      axios.post('/logout')
        .then(response => {
          if (response.status === 200) {
            logout()
            window.location.replace('/')
          }
        })
    }

    render () {
      return (
        this.props.user
          ? <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            debounce={250}
            timeout={1000 * 60 * this.props.session_lifetime}
            onIdle={this.handleOnIdle}/> : null

      )
    }
}

const mapStateToProps = state => ({
  user: state.app.user,
  session_lifetime: state.app.session_lifetime
})

export default connect(
  mapStateToProps,
  null
)(IdleHandler)
